import React from 'react';
import ChatInterface from '../components/ChatInterface';

/**
 * This page is exclusively for the Iframe/Widget.
 * It renders ONLY the chat interface with no margins or extra website elements.
 */
function ChatEmbedPage() {
  return (
    <div className="fixed inset-0 w-full h-full bg-transparent overflow-hidden">
      <ChatInterface isEmbed={true} />
    </div>
  );
}

export default ChatEmbedPage;